import { useEffect, useState, useCallback } from 'react';
import config from '../config';

const isAdminUser = (user) => user?.roles?.includes('administrator');

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) { return resolve(); }

    const scriptEl = document.createElement('script');
    scriptEl.src = src;
    scriptEl.async = true;
    scriptEl.onload = resolve;
    scriptEl.onerror = () => reject(new Error('Feedback widget script failed to load'));
    document.body.appendChild(scriptEl);
  });

const useFeedbackWidget = (currentUser) => {
  const [active, setActive] = useState(false);

  const showFeedbackWidget = useCallback(() => {
    if (active) { window.FlatWorldFeedbackWidget?.showForm(); }
  }, [active]);

  useEffect(() => {
    if (!currentUser || isAdminUser(currentUser)) { return setActive(false); }

    const run = async () => {
      try {
        const data = await (await fetch(`${config.api.DOMAIN}/api/feedback_widget/config`)).json();
        if (!data?.active || !data?.url) { return setActive(false); }

        await loadScript(`${data.url}/widget.js`);

        window.FlatWorldFeedbackWidget?.init({
          api_url: `${data.url}/api/responses`,
          user_name: currentUser.firstname,
          user_uuid: currentUser.uuid,
          show_fab: false,
        });

        setActive(true);
      } catch {
        setActive(false);
      }
    };

    run();
  }, [currentUser]);

  return { isFeedbackWidgetActive: active, showFeedbackWidget };
};

export default useFeedbackWidget;
